import { ClientInfo } from 'typings/brands'
import { I18N } from 'typings/custom'
import { REGISTERED_TRADEMARK } from 'const/text'
import customerSupport from './customerSupport'

const P66_BRAND = `Phillips 66${REGISTERED_TRADEMARK} - Conoco${REGISTERED_TRADEMARK} - 76${REGISTERED_TRADEMARK}`

// clientName is the only value know currently , update other values once received
const clientInfo: ClientInfo = {
  clientName: 'p66',
  displayName: P66_BRAND,
  alternateDisplayName: 'P66',
  languages: ['en'],
  vanityUrl: '',
  hostname: 'p66.syf.com',
  logoAltText: 'Phillips66 Conoco 76',
  loginHeaderType: 'background',
  invoiceDetailLogoAltText: 'Phillips66 Conoco 76',
  isShowOnlineAdministrator: false,
  video: {
    brcVideoListPath: '/one2many/commercial/video/video-list-brc.json',
    videoHost: 'https://player.vimeo.com/video/'
  },
  apigeeClientId: {
    development: 'Au9uAZlMCH1jNbZyA2PYxvw9d3YuVMAX',
    production: 'EdUlxBRW74vFdSAYVWviPuDRTtD6dPyQ'
  },
  customerSupport,
  address: {
    payment: {
      city: '',
      state: '',
      streetNumber: '',
      postalCode: ''
    },
    paymentResearch: {
      city: '',
      state: '',
      streetNumber: '',
      postalCode: ''
    },
    consent: {
      city: 'El Paso',
      state: 'TX',
      streetNumber: '79998-1064',
      postalCode: '981064'
    },
    businessPayments: {
      city: '',
      state: '',
      streetNumber: '',
      postalCode: ''
    }
  },
  legacySiteUrl: '',
  websiteUrl: 'myphillips66card.com/commercial/',
  consentToEcomUrl: `https://apply.syf.com/cs/groups/public/documents/et_appdoc/e026921.html`,
  lookUpUserIdUrl: ``,
  privileges: {
    brc: {
      manageUser: 0,
      payments: 2,
      missingPayment: 3,
      editBusinessInfo: 5,
      closeAccount: 20,
      disputeInvoice: 9,
      creditLineIncrease: 10,
      lostCard: 12,
      taxforms: 15,
      missingCredit: 16,
      editUserInformation: 19
    }
  },
  showWelcomeMat() {
    return true
  },
  showCardReissueModal() {
    return false
  },
  getLoginWelcomeMessage(i18n: I18N) {
    return i18n(
      {
        login:
          'Manage your %displayName% Commercial Credit Card account online from any device anytime, anywhere'
      },
      { displayName: P66_BRAND }
    ) as string
  },
  getTransactionClientName() {
    return P66_BRAND
  }
}

export default clientInfo
